export const constants = {
  id: 'team',
  name: 'Team',
  title: 'Our Members',
};

export const members = [
  {
    id: 'gmb',
    image: '',
    name: 'GONG MB',
    position: 'Developer',
    social: [],
  },
  {
    id: 'kgw',
    image: 'https://avatars.githubusercontent.com/u/39755330?v=4',
    name: 'KIM GW',
    position: 'Software Engineer',
    social: [
      'https://www.linkedin.com/in/kgeonw/',
      'https://github.com/kgeonw',
    ],
  },
  {
    id: 'ksh',
    image:
      'https://avatars.githubusercontent.com/u/78329874?s=400&u=90ac26843520cb2224bb92d4bbd7e911a521fea8&v=4',
    name: 'KIM SH',
    position: 'Front-End Developer',
    social: [
      'https://github.com/kimseoha1993',
      'https://www.behance.net/kimseoha1993',
    ],
  },
  {
    id: 'rhj',
    image: '',
    name: 'RYU HJ',
    position: 'Developer',
    social: [],
  },
  {
    id: 'lhj',
    image: '',
    name: 'LEE HJ',
    position: 'Developer',
    social: [],
  },
  {
    id: 'hsg',
    image: '',
    name: 'HONG SG',
    position: 'Developer',
    social: [],
  },
];
